import { color } from '@/constants/index';

export function SorryPage() {
  return (
    <div
      style={{
        color: color.customDarkGray,
        margin: 0,
      }}
    >
      <div
        style={{
          width: '100vw',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            fontSize: '40px',
            margin: 0,
          }}
        >
          ページが見つかりませんでした@elcompath
        </div>
      </div>
    </div>
  );
}
